import { useCallback } from 'react';
import { useNavigate, NavigateOptions, To, NavigateFunction } from 'react-router-dom';
import { useAppContext } from '../context/App.context';
import { VALID_LANGUAGE_PREFIXES } from '../app.utils';

export const useLocalizedNavigate = (): NavigateFunction => {
  const navigate = useNavigate();
  const { language } = useAppContext();

  const localizedNavigate: NavigateFunction = useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        // If the argument is a number (go back/forward), behave like history.go(n)
        return navigate(to);
      }

      const toStr = to.toString();
      const isMissingLangPrefix =
        toStr.startsWith('/') && !VALID_LANGUAGE_PREFIXES.includes(toStr.slice(0, 5));
      const fixedTo = isMissingLangPrefix ? `/${language}${toStr}` : to;

      return navigate(fixedTo, options);
    },
    [navigate, language]
  );

  return localizedNavigate;
};
